module.exports = __webpack_public_path__ + "static/media/special-crown.ec3791ba.png";